<template>
  <div class="annexesList">
    <el-table ref="annexesTable" :size="size" :data="initTableData" border :height="height" stripe style="width: 100%;"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
         <el-table-column prop="accessUrl" :label="$t('configMoudle.fileType')" align="center" width="100">
        <template slot-scope="{row}">
           <el-select @change="handleFileTypeChange(row)" size="mini" v-model="row.fjlx" class="file-type-select">
                 <el-option v-for="option in fileDictList" :key="option.value" :value="option.value" :label="option.label">
                 </el-option>
           </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="realAttachName" :label="$t('configMoudle.fileName')" align="center" min-width="140"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="accessUrl" :label="$t('configMoudle.thumbnail')" align="center" width="80">
        <template slot-scope="{row}">
          <el-image v-if="row.accessUrl" :preview-src-list="[row.accessUrl]" fit="contain"
            :src="row.accessUrl">
            <div slot="error">
              <el-tag size="mini">{{ checkFileType(row.realAttachName) }}</el-tag>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('configMoudle.createBy')" width="80" align="center"></el-table-column>
      <el-table-column prop="createTime" :label="$t('userAdmin.createTime')" width="140" align="center"></el-table-column>
      <el-table-column :label="$t('LanguageSet.operation')" align="center" width="100">
        <template slot-scope="{$index, row}">
          <i class="el-icon-download" style="cursor: pointer" @click="handleEdit($index, row)"></i>
          <i class="el-icon-delete-solid" v-if="showDel" style="margin-left: 5px;cursor: pointer"
            @click="handleVirtualDel($index, row)"></i>
          <i class="el-icon-view" style="margin-left: 5px;cursor: pointer" @click="handleView($index, row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="$t('configMoudle.tip')" :visible.sync="dialogVisible" append-to-body width="30%">
      <span>{{ $t('addTips.comfirmDelet') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('configMoudle.cancel') }}</el-button>
        <el-button type="primary" @click="dialogVisibleok">{{ $t('configMoudle.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dictFind } from "@/api/dict";
import { dictItem } from "_api/sysTem/index";
import request from "@/axios/index";

export default {
  name: "AnnexesList",
  data() {
    return {
      dialogVisible: false,
      rowList: {},
      multipleSelection: [],
      fileDictList:[],
    };
  },
  props: {
    size: {
      type: String,
      default: 'mini'
    },
    height: {
      type: Number,
      default: 196
    },
    tableData: {
      type: Array
    },
    detailConfig:{},
    showDel: {
      type: Boolean
    }
  },
  computed:{
  initTableData(){

     const  r = this.tableData?.map(t=>({
      ...(t||{}),
      fjlx: String(t.fjlx)
     }))
    return r
  }
  },
  watch: {
    initTableData() {
      this.refreshTableLayout()
    },
    fileDictList() {
      this.refreshTableLayout()
    }
  },
  created() { },
  mounted() {
   this.getFileTypeDict()
    
   },
  methods: {
  refreshTableLayout() {
    this.$nextTick(() => {
      this.$refs.annexesTable && this.$refs.annexesTable.doLayout()
    })
  },
  async handleFileTypeChange(row){
    try{
          console.log(row)
   const r = await request({
     method: "post",
       url: "/common/association/updateAssociation",
       data: row,
   })
        this.$message.success(this.$t("addTips.done"));

    }catch(e){
      console.log(e)
    }

  },
   async getFileTypeDict(){
    console.log(this?.detailConfig)
    const dictId = this?.detailConfig?.fileDicId || '2013876685782540288'
    const res = await dictItem({ method: "get", reqInfo: { dicId:dictId,pageNum:1,pageSize:9999999 } }) 
 

    this.fileDictList = res?.result?.map(dic=>({
      label: dic.englishName,
      value: dic.itemValue
    }))

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkFileType(string) {
      return string.substring(string.lastIndexOf(".") + 1, string.length).toUpperCase()
    },
    dialogVisibleok() {
      this.$emit("bindAnnexesDel", this.rowList)
      this.dialogVisible = false
    },
    handleEdit(index, row) {
      this.$emit("bindAnnexesDownload", row)
    },
    handleVirtualDel(index, row) {
      this.rowList = row
      this.dialogVisible = true
    },
    handleView(index, row) {
      this.$emit("bindAnnexesView", row)
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table .cell {
  height: 30px;
  line-height: 30px;
}
/deep/ .el-table th:first-child .cell {
  padding-left: 10px !important;
}
/deep/ .file-type-select {
  width: 100%;
}
</style>
